"use strict";var e=require("react"),a=require("styled-components");function t(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var r=t(e),o=t(a);const l=o.default.span`
    background-color: var(--switch-color);
    border-radius: 20px;
    cursor: pointer;
    display: block;
    height: calc(19px * var(--scaler));
    width: calc(39px * var(--scaler));
    line-height: 1;
    position: relative;
    transition: background-color 0.1s ease-in 0s;
    box-shadow: 0 0 0 2.1px var(--switch-color-focus-outline-focused);
    &:hover {
        box-shadow: 0 0 0 2px white, 0 0 0 3px var(--switch-color);
    }
`,s=o.default.span`
    --x-offset: 0;
    --x-gutter-size: 3px;
    background: rgb(247, 249, 251);
    border-radius: 20px;
    display: block;
    position: absolute;
    transition: all 0.2s ease-in 0s;
    width: calc(13px * var(--scaler));
    height: calc(13px * var(--scaler));
    box-shadow: 0px 1px 1px rgb(0 0 0 / 43%);
    top: 50%;
    left: var(--x-gutter-size);
    transform: translate(var(--x-offset), -50%);
    ${l}.on & {
        --x-offset: calc(200% - calc(var(--x-gutter-size) * 2));
    }
`;module.exports=({on:e,disabled:a,children:t})=>r.default.createElement(r.default.Fragment,null,r.default.createElement(l,{className:e?"on":""},r.default.createElement(s,null)),r.default.createElement("span",null,t));
//# sourceMappingURL=Default.js.map
